import _ from 'lodash';

const LETTER_LENGTH = 2;

/**
 * @type {Object}
 */
export const contactTypes = {
  OWNER: 'owner',
  GUEST: 'guest',
};

/**
 * @type {Object}
 */
export const NUMBER_TYPES = {
  HOME: 'home',
  MOBILE: 'mobile',
  OTHER: 'other',
  WORK: 'work',
};

/**
 * @type {Array}
 */
export const NUMBER_TYPE_OPTIONS = [
  { value: 'home', label: 'Home' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'other', label: 'Other' },
  { value: 'work', label: 'Work' },
];

/**
 * @type {Function}
 */
export const formatStateValue = (country, state) => {
  if (_.includes(['US', 'CA'], _.toUpper(country)) && _.size(state) === LETTER_LENGTH) {
    return _.toUpper(state);
  }

  return state;
};
